export enum LoaderEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SPINNER = 'spinner',
}
